var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[_c('AuthWindow',{on:{"afterLogin":_vm.afterLogin}}),_c('SimiaWelcomeModal',{model:{value:(_vm.simiaWelcomeModal),callback:function ($$v) {_vm.simiaWelcomeModal=$$v},expression:"simiaWelcomeModal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }